import ResponsiveImage from "./ResponsiveImage";

const FlexTable = ({ data }) => (
  <table className="flex-table">
    <thead>
      <tr>
        <th className="date">Date</th>
        <th className="title">Name</th>
        <th className="location">Location</th>
        <th className="length">Distance</th>
        <th className="elevation">Elevation</th>
        <th className="altitude">Altitude</th>
        <th className="rating">Rating</th>
        <th className="photo">📷</th>
      </tr>
    </thead>
    <tbody>
      {data.map((row, index) => (
        <tr key={index}>
          <td className="date">
            <span className="date-color">{row.date}</span>
          </td>
          <td className="title">
            <a href={row.notes} target="_blank" rel="noopener noreferrer">
              {row.name} ↗
            </a>
          </td>
          <td className="location">{row.location}</td>
          <td className="length txt">{row.distance}km</td>
          <td className="elevation txt">{row.elevation}m</td>
          <td className="altitude txt">{row.altitude}m</td>
          <td className="rating txt">{"⭐️".repeat(row.rating)}</td>
          <td className="photo">
            <div className="img-wrapper">
              {row.photo_url ? (
                <ResponsiveImage imagePath={row.photo_url} alt={row.name} />
              ) : (
                <div className="no-image">No Image</div>
              )}
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default FlexTable;
